var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_573)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5005 8.2564C17.5005 9.20846 17.1317 10.1215 16.4752 10.7947C15.8187 11.4679 14.9284 11.8461 14 11.8461C13.0716 11.8461 12.1813 11.4679 11.5248 10.7947C10.8683 10.1215 10.4995 9.20846 10.4995 8.2564C10.4995 7.30434 10.8683 6.39127 11.5248 5.71807C12.1813 5.04486 13.0716 4.66666 14 4.66666C14.9284 4.66666 15.8187 5.04486 16.4752 5.71807C17.1317 6.39127 17.5005 7.30434 17.5005 8.2564ZM7 21.7711C7.03 19.8875 7.78069 18.0915 9.09018 16.7703C10.3997 15.4492 12.163 14.7088 14 14.7088C15.837 14.7088 17.6003 15.4492 18.9098 16.7703C20.2193 18.0915 20.97 19.8875 21 21.7711C18.8039 22.8037 16.4159 23.3367 14 23.3333C11.5021 23.3333 9.13108 22.7743 7 21.7711Z",
    stroke: "#2F2F2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7d8cd1c814c8ee2236426adcb5f633d4.svg";
export { ForwardRef as ReactComponent };